export default __webpack_public_path__ + "static/ai-solutions-with-roadmap3-6a5c7d27404225b5c83ee3703b8514a1.jpg";